import { render } from "./DisplayPage.vue?vue&type=template&id=63749b6c&scoped=true"
import script from "./DisplayPage.vue?vue&type=script&lang=js"
export * from "./DisplayPage.vue?vue&type=script&lang=js"

import "./DisplayPage.vue?vue&type=style&index=0&id=63749b6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63749b6c"]])

export default __exports__